export default {"src":"/_next/static/media/discord.9f4bc1d9.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};